var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "content-modules-wrapper",
    },
    [
      _c(
        "draggable",
        {
          attrs: {
            handle: ".dragarea",
          },
          model: {
            value: _vm.sortedModules,
            callback: function callback($$v) {
              _vm.sortedModules = $$v
            },
            expression: "sortedModules",
          },
        },
        [
          _c(
            "transition-group",
            {
              staticClass: "admin_contentmodules studip-grid",
              attrs: {
                name: "admin_contentmodules",
                tag: "div",
                role: "listbox",
              },
            },
            _vm._l(_vm.activeModules, function (module) {
              return _c(
                "div",
                {
                  key: module.id,
                  staticClass: "studip-grid-element",
                  class: _vm.getModuleCSSClasses(
                    module,
                    _vm.activated[module.id]
                  ),
                  attrs: {
                    role: "option",
                  },
                },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "upper_part dragarea",
                        attrs: {
                          href: _vm.getDescriptionURL(module),
                          "data-dialog": "",
                        },
                      },
                      [
                        _c("div", [
                          module.icon
                            ? _c("img", {
                                attrs: {
                                  src: module.icon,
                                  width: "40",
                                  height: "40",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("h3", [_vm._v(_vm._s(module.displayname))]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(module.summary) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "down_part",
                      },
                      [
                        _c("div", [
                          _vm.filterCategory === null
                            ? _c(
                                "a",
                                {
                                  ref: "draghandle-".concat(module.id),
                                  refInFor: true,
                                  staticClass: "dragarea",
                                  attrs: {
                                    tabindex: "0",
                                    "aria-label": _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Sortierelement für Werkzeug %{module}. Drücken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben."
                                      ),
                                      {
                                        module: module.displayname,
                                      },
                                      true
                                    ),
                                  },
                                  on: {
                                    keydown: function keydown($event) {
                                      return _vm.keyboardHandler($event, module)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "drag-handle",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !module.mandatory
                            ? _c("label", [
                                _c("input", {
                                  ref: "checkbox_" + module.id,
                                  refInFor: true,
                                  attrs: {
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: _vm.activated[module.id],
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.toggleModule(module)
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$gettext("Werkzeug ist aktiv")) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "icons_right",
                          },
                          [
                            _vm.showVisibilityToggle(module)
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "toggle_visibility",
                                    attrs: {
                                      href: "#",
                                      role: "checkbox",
                                      "aria-checked":
                                        module.visibility !== "tutor"
                                          ? "true"
                                          : "false",
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        return _vm.toggleModuleVisibility(
                                          module
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("studip-icon", {
                                      staticClass: "text-bottom",
                                      attrs: {
                                        shape:
                                          module.visibility !== "tutor"
                                            ? "visibility-visible"
                                            : "visibility-invisible",
                                        title: _vm.$gettextInterpolate(
                                          _vm.$gettext(
                                            "Inhaltsmodul %{ name } für Teilnehmende unsichtbar bzw. sichtbar schalten"
                                          ),
                                          {
                                            name: module.displayname,
                                          },
                                          true
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getRenameURL(module),
                                  "data-dialog": "size=medium",
                                },
                              },
                              [
                                _c("studip-icon", {
                                  staticClass: "text-bottom",
                                  attrs: {
                                    shape: "edit",
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Umbenennen des Inhaltsmoduls %{ name }"
                                      ),
                                      {
                                        name: module.displayname,
                                      },
                                      true
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "admin_contentmodules studip-grid inactive-modules",
          attrs: {
            name: "admin_contentmodules",
            tag: "div",
            role: "listbox",
          },
        },
        _vm._l(_vm.inactiveModules, function (module) {
          return _c(
            "div",
            {
              key: module.id,
              staticClass: "studip-grid-element",
              class: _vm.getModuleCSSClasses(module, _vm.activated[module.id]),
              attrs: {
                role: "option",
              },
            },
            [
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "upper_part",
                    attrs: {
                      href: _vm.getDescriptionURL(module),
                      "data-dialog": "",
                    },
                  },
                  [
                    _c("div", [
                      module.icon
                        ? _c("img", {
                            attrs: {
                              src: module.icon,
                              width: "40",
                              height: "40",
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("h3", [_vm._v(_vm._s(module.displayname))]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(module.summary) +
                          "\n                    "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "down_part",
                  },
                  [
                    _c("div", [
                      !module.mandatory
                        ? _c("label", [
                            _c("input", {
                              ref: "checkbox_" + module.id,
                              refInFor: true,
                              attrs: {
                                type: "checkbox",
                              },
                              domProps: {
                                checked: _vm.activated[module.id],
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.toggleModule(module)
                                },
                              },
                            }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$gettext("Werkzeug ist inaktiv")) +
                                "\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }